import { get,post } from "@/plugin/newAxios";

//查询
export const getMsgQryListApi = params => post("/khfw/v1/message/queryMessage",params)

//删除/已读
export const updateMsgApi = params => get("/khfw/v1/message/updateMsg/" + params.msgId + '/' + params.flag)

//查看详情
export const viewMsgApi = id => get("/khfw/v1/message/queryByMsgId/" + id)

//未读条数
export const queryMsgTotalApi = readFlag => get("/khfw/v1/message/queryMsgTotal/" + readFlag)
